//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/Builder.js";
import "../DiagrammingLibraryAuthor/DiagrammingLibraryAuthor.LineTypeBuilderList.js";
import "../DiagrammingLibraryAuthor/DiagrammingLibraryAuthor.PipeStockBuilder.js";
import "../DiagrammingLibraryAuthor/DiagrammingLibraryAuthor.Symbol2DBuilder.js";
import "../DiagrammingLibraryAuthor/DiagrammingLibraryAuthor.Symbol3DBuilder.js";
import "../no/DiagrammingLibraryAuthor.js";
import "../no/ObjectList.js";
let d=[[[1,"LineTypes",0,"DiagrammingLibraryAuthor.LineTypeBuilderList",0],[0,"OutputFolder",1,0],[1,"PipeStock",0,"DiagrammingLibraryAuthor.PipeStockBuilder",0],[1,"Symbol2D",0,"DiagrammingLibraryAuthor.Symbol2DBuilder",0],[1,"Symbol3D",0,"DiagrammingLibraryAuthor.Symbol3DBuilder",0]],[[["classId","symbolId"],"SelectFolder",{},2,0],[["symbolId"],"SelectSymbol",{},1,0],[[],"CreateLineType",{R_:{lineType:"DiagrammingLibraryAuthor.LineTypeBuilder"}},0,0],[["num_objects","symbolObjects"],"GetSymbolObjects",{},0,0],[["instanceId","partId","partName","numberName"],"Create3DSymbol",{R_:{symbolObject:"DiagrammingLibraryAuthor.AttributeHolder"}},4,0],[["symbolObject"],"Delete3DSymbol",{},1,0]],[]];
SPLM.PID.LibraryAuthoringBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.LibraryAuthoringBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;